export function valueFrom({defaultValue, name, objects}) {
  const source = objects.find((object) => object[name] != null);

  if(source) { return source[name]; }
  if(defaultValue != null) { return defaultValue; }

  return "";
}

export function valueFromTarget({checked, name, type, value}) {
  if(type === "checkbox") { return checked; }
  if(name.endsWith("_ids")) { return (value || []).map(Number); }

  return value;
}
